import { observer } from "mobx-react";
import React from "react";
import { WorkingInterval } from "@fidget/common/utils/getWorkingHours";
import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";
import { DateTimeDropdown, DatetimeDropdownMode } from "../../dateTimePicker/dateTimeDropdown";
import { WorkingDay } from "@fidget/common/models/workingDay";
import styles from "./workingHoursRow.css";

interface Props {
  day: WorkingDay;
  onChange: (newWorkingInterval: WorkingInterval) => void;
  timePickerWidth?: string;
}

export const WorkingHoursRow = observer(({ day, onChange, timePickerWidth = "100px" }: Props) => {
  const enableWorkingHours = () => {
    onChange(day.previousDayInterval);
  };

  const disableWorkingHours = () => {
    onChange({ from: day.dayStart, to: day.dayStart });
  };

  const onChangeFrom = (from: number) => {
    if (from > day.interval.to.value) {
      onChange({ from, to: day.dayEnd });
    } else {
      onChange({ from, to: day.interval.to.value });
    }
  };

  const onChangeTo = (to: number) => {
    if (to < day.interval.from.value) {
      onChange({ from: day.dayStart, to });
    } else {
      onChange({ from: day.interval.from.value, to });
    }
  };

  return (
    <div className={styles["day-container"]}>
      <AgentButton
        buttonStyle={day.isDisabled ? "outlined primary" : "primary"}
        onClick={day.isDisabled ? enableWorkingHours : disableWorkingHours}
      >
        <span className={styles["day-name"]}>{day.name}</span>
      </AgentButton>
      <div className={styles["inputs-container"]}>
        <DateTimeDropdown
          startingPoint={day.fromAsDate}
          mode={DatetimeDropdownMode.TIME}
          options={day.fromTimesOptions}
          onChange={(value) => onChangeFrom(value.getTime())}
          id={day.name + "_from"}
          width={"100px"}
          height={"27px"}
          marginBottom={"0px"}
        />
        <div className={styles.hyphen}> - </div>
        <DateTimeDropdown
          startingPoint={day.toAsDate}
          mode={DatetimeDropdownMode.TIME}
          options={day.toTimesOptions}
          onChange={(value) => onChangeTo(value.getTime())}
          id={day.name + "_to"}
          width={timePickerWidth}
          height={"27px"}
          marginBottom={"0px"}
        />
      </div>
    </div>
  );
});
